// extracted by mini-css-extract-plugin
export default {"row":"Info_row__NVHgS","title":"Info_title__0Gfgv","img":"Info_img__xk30Y","text":"Info_text__n9tgy"};